import { addDays } from 'date-fns';

/* Règles de date et d'heure communes à toutes les fermetures d'enregistrement
   (simple, pêche et chasse) */

export const DATE_ERROR_KEYS = {
  BEFORE_ARRIVE: 'errorDateBeforeArrive',
  AFTER_DEPART_MAX: 'errorDateAfterDepartMax',
  AFTER_TODAY: 'errorDateAfterToday',
};

export function formatDateToISOWithoutZ(dateValue) {
  const pad = (num) => num < 10 ? '0' + num : num;

  const year = dateValue.getFullYear();
  const month = pad(dateValue.getMonth() + 1);
  const day = pad(dateValue.getDate());
  const hours = pad(dateValue.getHours());
  const mins = pad(dateValue.getMinutes());
  const seconds = pad(dateValue.getSeconds());

  return `${year}-${month}-${day}T${hours}:${mins}:${seconds}`;
}

export function getSelectableDateBounds(dateArrivee, dateDepart) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const maxDateTime = dateDepart ? addDays(dateDepart, 14) : null;

  const minSelectableDate = dateArrivee
    ? (() => {
      const min = new Date(dateArrivee);
      min.setHours(0, 0, 0, 0);
      return min;
    })()
    : new Date(1900, 0, 1);

  const maxSelectableDate = (() => {
    if (!maxDateTime) {
      return today;
    }
    const maxDay = new Date(maxDateTime);
    maxDay.setHours(0, 0, 0, 0);
    return maxDay < today ? maxDay : today;
  })();

  return { minSelectableDate, maxSelectableDate, maxDateTime, today };
}

export function isDateTimeBeforeArrivee(dateArrivee, dateValue, heureValue, minutesValue) {
  if (!dateArrivee || !dateValue) {
    return false;
  }
  const dateFermeture = new Date(dateValue);
  dateFermeture.setHours(heureValue, minutesValue, 0, 0);
  return dateFermeture < dateArrivee;
}

export function isDateTimeAfterMaxDepart(maxDateTime, dateValue, heureValue, minutesValue) {
  if (!dateValue || !maxDateTime) {
    return false;
  }
  const dateFermeture = new Date(dateValue);
  dateFermeture.setHours(heureValue, minutesValue, 0, 0);
  return dateFermeture > maxDateTime;
}

export function isDateTimeAfterNow(dateValue, heureValue, minutesValue) {
  if (!dateValue) {
    return false;
  }
  const dateFermeture = new Date(dateValue);
  dateFermeture.setHours(heureValue, minutesValue, 0, 0);
  return dateFermeture > new Date();
}

export function validateSelectedDate({ dateValue, dateArrivee, minSelectableDate, maxSelectableDate, today }) {
  const selected = new Date(dateValue);
  selected.setHours(0, 0, 0, 0);
  if (dateArrivee && selected < minSelectableDate) {
    return DATE_ERROR_KEYS.BEFORE_ARRIVE;
  }
  if (selected > today) {
    return DATE_ERROR_KEYS.AFTER_TODAY;
  }
  if (selected > maxSelectableDate) {
    return DATE_ERROR_KEYS.AFTER_DEPART_MAX;
  }
  return '';
}

export function validateDateTime({ dateValue, heureValue, minutesValue, dateArrivee, maxDateTime }) {
  if (isDateTimeBeforeArrivee(dateArrivee, dateValue, heureValue, minutesValue)) {
    return DATE_ERROR_KEYS.BEFORE_ARRIVE;
  }
  if (isDateTimeAfterMaxDepart(maxDateTime, dateValue, heureValue, minutesValue)) {
    return DATE_ERROR_KEYS.AFTER_DEPART_MAX;
  }
  if (isDateTimeAfterNow(dateValue, heureValue, minutesValue)) {
    return DATE_ERROR_KEYS.AFTER_TODAY;
  }
  return '';
}

export function buildSimpleFermeturePayload({ idProfile, dateFermetureISO, idEnregistrementEntete }) {
  return {
    IdProfile: idProfile,
    DateFermeture: dateFermetureISO,
    IdEnregistrementEntete: idEnregistrementEntete,
  };
}
